import React from 'react';
export function VideoSection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-931">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-932">
        <div className="mb-12" data-id="element-933">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-934">
            Watch CAS in Action
          </h2>
          <div className="rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0',
          aspectRatio: '16/9'
        }} data-id="element-935">
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/iFcDUNWU8Lo?controls=0" title="Cowboy Action Shooting video" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="w-full h-full" style={{
            aspectRatio: '16/9'
          }} data-id="element-936" />
          </div>
        </div>
      </div>
    </div>;
}